import { render } from "./CategoryDeleteForm.vue?vue&type=template&id=10a0b449"
import script from "./CategoryDeleteForm.vue?vue&type=script&lang=js"
export * from "./CategoryDeleteForm.vue?vue&type=script&lang=js"
script.render = render

export default script